
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvBookingSeatingLayout.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import { EvBookingCopyForm } from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import "../../../moreCore/UI/SearchSelect/SearchSelect";
class EvBookingSeatingLayout extends compose(_StatefulSection) {
    templateString: any = template;

    audienceSeatingLayoutInput: MdsLax<InstanceType<typeof SearchSelect>>;
    private roomId: string;

    afterSetData() {
        let data = this.sourceData as VAM2types.AudienceSeatingLayout;
    }

    onDirtyChange(currentState: boolean) {
        
    }

    setRoomId(roomID: string, resetSelection: boolean = true) {
        let data = this.currentData as VAM2types.AudienceSeatingLayout;

        if (resetSelection) {
            this.audienceSeatingLayoutInput.setValue(null);
            this.currentData = null;
        }

        this.roomId = roomID;
        this.audienceSeatingLayoutInput.setRequestParameter("roomId", roomID);
        this.audienceSeatingLayoutInput.loadListValues(this.currentData ? this.currentData : null);
    }

    _onChanged(key: string, value: any) {
        //console.debug(this.id + " _onChanged " + key, value);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {

        if (!this.hasFeature("EvBooking/SeatingLayout")) return;
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvBookingSeatingLayout);